<template>
  <GenericStep v-bind="$attrs">
    <div
      v-for="aka of peParty.akas"
      :key="aka.id"
      class="mb-12"
    >
      <AKACard
        :item="aka"
      />
    </div>

    <SectionAdderLine
      section="AKA"
      :has-new-section="peAKACardHasNewSection"
      @on-add="peAKACardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import AKACard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/AKACard.vue'
import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'AliasesStep',

  components: {
    AKACard,
    GenericStep,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.akas
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peAKACardHasNewSection',
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peAKACardAddSection',
    ]),
  },
}
</script>
